<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账户名：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">密码：</span>
        </div>
        <el-input v-model="formData.password" type="password" size="small" style="width: 280px" />
        <span style="color: #999999; font-size: 12px;">请输入8至20位无特殊字符的密码</span>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">确认密码：</span>
        </div>
        <el-input v-model="formData.confirmPassword" type="password" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系人姓名：</span>
        </div>
        <el-select v-model="personCode" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" size="mini" style="width: 280px">
          <el-option
            v-for="item in actualList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系人手机：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" disabled />
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<span class="line-text">联系人邮箱：</span>-->
        <!--</div>-->
        <!--<el-input v-model="formData.email" size="small" style="width: 280px" disabled />-->
      <!--</div>-->
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">账号归属：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.enterpriseCode" placeholder="请选择" size="mini" style="width: 280px">-->
          <!--<el-option-->
            <!--v-for="item in enterpriseList"-->
            <!--:key="item.code"-->
            <!--:label="item.enterpriseName"-->
            <!--:value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">上级账号：</span>
        </div>
        <el-select v-model="formData.parentCode" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in accountList"
            :key="item.code"
            :label="item._labelName"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联角色：</span>
        </div>
        <el-select v-model="formData.roleCode" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in roleList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">关联住户：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.enterpriseCode" placeholder="请选择" size="mini" style="width: 280px">-->
          <!--<el-option-->
            <!--v-for="item in enterpriseList"-->
            <!--:key="item.code"-->
            <!--:label="item.enterpriseName"-->
            <!--:value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否可复用：</span>
        </div>
        <el-switch
          v-model="multiplexing"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { api } from "../../api/Account";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "account-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "资源中心",
          name: "yq-information"
        },
        {
          value: "子账号管理"
        }
      ],
      mainTitle: "创建账户",
      subheading: "创建访问平台的账户，关联访问权限",
      roleList: [],
      multiplexing: false,
      buildingList: [],
      accountList: [],
      enterpriseList: [],
      actualList: [],
      personCode: "",
      formData: {
        name: "",
        personCode: "",
        actualName: "",
        password: "",
        confirmPassword: "",
        phone: "",
        email: "",
        parentCode: "",
        roleCode: "",
        roleName: "",
        enterpriseCode: "",
        enterpriseName: "",
        isReuse: ""
      }
    };
  },
  created() {
    // this.getEnterpriseList()
    this.getRoleList();
    this.getAccountList();
    // this.getResponsiblePerson();
    this.remoteMethod();
  },
  methods: {
    toAccountManagementPage() {
      this.$router.push({
        name: "account-management"
      });
    },

    remoteMethod(query) {
      this.getResponsiblePerson(query);
    },
    // 获取人员列表
    getResponsiblePerson(searchKey) {
      this.$axios
        .post(api.getResponsiblePerson, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.actualList = data;
          }
        })
        .catch(errorHandler("获取人员列表失败"));
    },

    // 获取账户列表
    getAccountList() {
      this.$axios
        .post(api.getAccountList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data.length > 0) {
              data.map(v => {
                v._labelName = `${v.name} / ${v.actualName ? v.actualName : ''}`;
              });
            }
            this.accountList = data;
          }
        })
        .catch(errorHandler("获取账户列表失败"));
    },

    // 获取住户列表
    getEnterpriseList() {
      this.$axios
        .post(api.getEnterpriseList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.enterpriseList = res.data.data;
          }
        })
        .catch(errorHandler("获取住户列表失败"));
    },
    // 获取角色列表
    getRoleList() {
      this.$axios
        .post(api.getRoleList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.roleList = res.data.data;
          }
        })
        .catch(errorHandler("获取角色列表失败"));
    },
    // 确认添加
    confirm() {
      let checkName = pattern.characterInput_24.test(this.formData.name);
      let checkActualName = pattern.characterInput_24.test(
        this.formData.actualName
      );
      let checkPassword = pattern.password.test(this.formData.password);
      let checkPhone = pattern.phone.test(this.formData.phone);
      if (!this.formData.name) {
        nError("请输入账户名");
        return false;
      } else {
        if (!checkName) {
          nError("账户名不允许有特殊字符或空格");
          return false;
        }
      }
      if (!this.formData.actualName) {
        nError("请输入联系人姓名");
        return false;
      } else {
        if (!checkActualName) {
          nError("联系人姓名不允许有特殊字符或空格");
          return false;
        }
      }
      if (!this.formData.password) {
        nError("请输入密码");
        return false;
      } else {
        if (!checkPassword) {
          nError("请输入8至20位无特殊字符的密码");
          return false;
        }
      }
      if (!this.formData.confirmPassword) {
        nError("请确认密码");
        return false;
      }
      if (!this.formData.phone) {
        nError("请输入联系人手机");
        return false;
      } else {
        if (!checkPhone) {
          nError("联系人手机格式不正确");
          return false;
        }
      }
      if (!this.formData.roleCode) {
        nError("请选择关联角色");
        return false;
      }
      if (this.formData.password !== this.formData.confirmPassword) {
        nError("两次密码不一致");
        return false;
      }
      // if (!this.formData.enterpriseCode) {
      //   nError('请选择关联住户')
      //   return false
      // }
      this.roleList.map(v => {
        if (this.formData.roleCode === v.code) {
          this.formData.roleName = v.name;
        }
      });
      // this.enterpriseList.map(v => {
      //   if (this.formData.enterpriseCode === v.code) {
      //     this.formData.enterpriseName = v.enterpriseName
      //   }
      // })
      if (this.multiplexing) {
        this.formData.isReuse = "1";
      } else {
        this.formData.isReuse = "0";
      }
      let name = this.formData.name.toLowerCase();
      let pw = this.formData.password + name;
      let once = md5(pw) + name;
      let pwd;
      for (let i = 0; i < 9; i++) {
        pwd = md5(once);
        once = pwd + name;
      }
      this.formData.password = pwd;
      this.$axios
        .post(api.addAccount, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toAccountManagementPage();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toAccountManagementPage();
    }
  },
  watch: {
    personCode() {
      this.actualList.map(v => {
        if (v.code === this.personCode) {
          this.formData.personCode = this.personCode;
          this.formData.actualName = v.name;
          this.formData.phone = v.phone;
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/AccountManagement/AccountAdd.vue